/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketCoverage,
    AdminMarketCoverageFromJSON,
    AdminMarketCoverageFromJSONTyped,
    AdminMarketCoverageToJSON,
} from './AdminMarketCoverage';
import {
    AdminWorkerKindStats,
    AdminWorkerKindStatsFromJSON,
    AdminWorkerKindStatsFromJSONTyped,
    AdminWorkerKindStatsToJSON,
} from './AdminWorkerKindStats';

/**
 * 
 * @export
 * @interface AdminWorkerStatusResp
 */
export interface AdminWorkerStatusResp {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerStatusResp
     */
    checkedAt: string;
    /**
     * 
     * @type {AdminMarketCoverage}
     * @memberof AdminWorkerStatusResp
     */
    coverage: AdminMarketCoverage;
    /**
     * 
     * @type {Array<AdminWorkerKindStats>}
     * @memberof AdminWorkerStatusResp
     */
    kinds: Array<AdminWorkerKindStats>;
    /**
     * LeaderExpiresAt: a running worker keeps moving it forward a few seconds ahead.
     * @type {string}
     * @memberof AdminWorkerStatusResp
     */
    leaderExpiresAt?: string;
    /**
     * LeaderSince is when the current (or last) worker process started leading.
     * @type {string}
     * @memberof AdminWorkerStatusResp
     */
    leaderSince?: string;
    /**
     * Paused: the job queue is paused from the Worker page; the worker takes no new jobs.
     * @type {boolean}
     * @memberof AdminWorkerStatusResp
     */
    paused: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerStatusResp
     */
    pausedAt?: string;
    /**
     * Running is true while a worker process holds River's leadership.
     * @type {boolean}
     * @memberof AdminWorkerStatusResp
     */
    running: boolean;
}

export function AdminWorkerStatusRespFromJSON(json: any): AdminWorkerStatusResp {
    return AdminWorkerStatusRespFromJSONTyped(json, false);
}

export function AdminWorkerStatusRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerStatusResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkedAt': json['checkedAt'],
        'coverage': AdminMarketCoverageFromJSON(json['coverage']),
        'kinds': ((json['kinds'] as Array<any>).map(AdminWorkerKindStatsFromJSON)),
        'leaderExpiresAt': !exists(json, 'leaderExpiresAt') ? undefined : json['leaderExpiresAt'],
        'leaderSince': !exists(json, 'leaderSince') ? undefined : json['leaderSince'],
        'paused': json['paused'],
        'pausedAt': !exists(json, 'pausedAt') ? undefined : json['pausedAt'],
        'running': json['running'],
    };
}

export function AdminWorkerStatusRespToJSON(value?: AdminWorkerStatusResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkedAt': value.checkedAt,
        'coverage': AdminMarketCoverageToJSON(value.coverage),
        'kinds': ((value.kinds as Array<any>).map(AdminWorkerKindStatsToJSON)),
        'leaderExpiresAt': value.leaderExpiresAt,
        'leaderSince': value.leaderSince,
        'paused': value.paused,
        'pausedAt': value.pausedAt,
        'running': value.running,
    };
}

